<template>
    <FormGroupNew :label="label" :description="description" required>
        <div v-if="exists">
            <i class="fas fa-check-circle text-success"/>
            {{ existsText }}

            <div class="mt-3">
                <button class="btn btn-xs btn-secondary btn-hover-primary" @click="triggerEdit">
                    <i class="fas fa-edit text-inherit"/>
                    {{ __('actions.edit') }}
                </button>
            </div>
        </div>
        <div v-else>
            {{ notExistText }}

            <div class="mt-3">
                <button class="btn btn-xs btn-light-primary" @click="triggerEdit">
                    <i class="fas fa-plus-square"/>
                    {{ __('actions.add') }}
                </button>
            </div>
        </div>
    </FormGroupNew>
</template>

<script>
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew},

    props: {
        label: String,
        description: String,
        exists: Boolean,
        existsText: String,
        notExistText: String,
    },

    methods: {
        triggerEdit() {
            this.$emit('edit')
        }
    }
}
</script>
